export default __webpack_public_path__ + "static/media/tiktoklogo.bfbbb1dc.svg";